// Simulation #2 — Block 1 (Screens 1–8) data. Deterministic, authored. No AI, no branching engine.
// Each screen: env (world state), hud, feed (in-game multiplayer chat, authored), actions -> next screen.
export const BLOCK_1_STAGE = "block_1";

export const PLAYERS = ["Kai_09", "mira.plays", "Sam17", "Tobs"];

export const SCREENS = {
  1: { env: "title", title: "WILD RUSH", sub: "Reach the ridge checkpoint to complete the trail.",
       actions: [{ id: "enter", label: "Enter the game", next: 2, event: "game_entered" }] },
  2: { env: "forest", objective: "Checkpoint 1 · 240m", caption: "The trail opens ahead. Other players are already moving.",
       feed: [{ who: "Kai_09", text: "anyone going the river way?" }, { who: "mira.plays", text: "ridge is faster if it’s not slippery" }],
       actions: [{ id: "move", label: "Keep moving", next: 3 }] },
  3: { env: "fork", objective: "Checkpoint 1 · 180m", caption: "The trail splits at the old signpost.",
       actions: [{ id: "river", label: "Take the river path", next: 4, event: "route_selected" },
                 { id: "ridge", label: "Follow the ridge", next: 5, event: "route_selected" }] },
  4: { env: "river", objective: "Checkpoint 1 · 90m", caption: "Fast water. Stepping stones lead across to the far bank.",
       actions: [{ id: "cross", label: "Cross here", next: 6 }] },
  5: { env: "ridge", objective: "Checkpoint 1 · 90m", caption: "Wind on the ridge. The marker glows below the pines.",
       actions: [{ id: "descend", label: "Head down to the marker", next: 6 }] },
  6: { env: "checkpoint", objective: "Checkpoint 1", caption: "A checkpoint beacon stands in the clearing. Two other players arrive just behind you.",
       feed: [{ who: "Tobs", text: "cp1 ✔" }, { who: "Kai_09", text: "that river bit is rough lol" }],
       actions: [{ id: "marker", label: "Check the marker", next: 7, event: "checkpoint_completed" }] },
  7: { env: "rocks", objective: "Checkpoint 2 · 310m", caption: "Beyond the clearing the path is blocked by fallen rock. A player ahead waves you over to a gap.",
       feed: [{ who: "Sam17", text: "there’s a gap by the big rock, this way" }],
       actions: [{ id: "follow", label: "Go through the gap", next: 8 }] },
  8: { env: "rocks", objective: "Checkpoint 2 · 260m", caption: "You’re through. The route ahead is clear again.",
       feed: [{ who: "Sam17", text: "nice — that part gets everyone first time" }],
       actions: [{ id: "play", label: "Keep playing", next: 9 }] },
};

export const FIRST_SCREEN = 1;
export const isValidTransition = (from, actionId) =>
  Boolean(SCREENS[from]?.actions.some((a) => a.id === actionId));
